module.exports = __webpack_public_path__ + "assets/img/1.20ea0d40.png";